module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon7.a614619b.svg";